import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DICTIONARY } from "../data/content";

const LanguageContext = createContext();

export function getDetectedLanguage() {
  try {
    if (typeof window !== "undefined") {
      const match = window.location.pathname.match(/^\/(id|en)(\/|$)/i);
      if (match) return match[1].toLowerCase();
    }
    const saved = localStorage.getItem("bma_lang");
    if (saved === "id" || saved === "en") return saved;
    const browserLang = (typeof navigator !== "undefined" && (navigator.language || navigator.userLanguage)) || "";
    return browserLang.toLowerCase().startsWith("id") ? "id" : "en";
  } catch (e) {
    return "id";
  }
}

export function LanguageProvider({ children }) {
  const location = useLocation();
  const navigate = useNavigate();

  const [lang, setLangState] = useState(() => getDetectedLanguage());

  // Keep state and localStorage in sync with URL when route changes
  useEffect(() => {
    const match = location.pathname.match(/^\/(id|en)(\/|$)/i);
    if (match) {
      const pathLang = match[1].toLowerCase();
      if (pathLang !== lang) {
        setLangState(pathLang);
        try {
          localStorage.setItem("bma_lang", pathLang);
        } catch (e) {}
      }
    }
  }, [location.pathname, lang]);

  // Sync document attributes and title
  useEffect(() => {
    try {
      document.documentElement.lang = lang;
      if (lang === "id") {
        document.title = "BERRY MOD APK — Masa Depan Modding Ada Disini!";
      } else {
        document.title = "BERRY MOD APK — The Future Of Modding is Here!";
      }
    } catch (e) {}
  }, [lang]);

  const setLang = useCallback(
    (newLang) => {
      const validLang = newLang === "id" ? "id" : "en";
      setLangState(validLang);
      try {
        localStorage.setItem("bma_lang", validLang);
        document.documentElement.lang = validLang;
      } catch (e) {}

      const pathname = location.pathname;
      const match = pathname.match(/^\/(id|en)(\/.*)?$/i);
      if (match) {
        const rest = match[2] || "/";
        navigate(`/${validLang}${rest}${location.search}${location.hash}`);
      } else {
        if (pathname === "/" || pathname === "") {
          navigate(`/${validLang}/`);
        } else {
          navigate(`/${validLang}${pathname}${location.search}${location.hash}`);
        }
      }
    },
    [location, navigate]
  );

  const toggleLang = useCallback(() => {
    setLang(lang === "id" ? "en" : "id");
  }, [lang, setLang]);

  const t = DICTIONARY[lang] || DICTIONARY.en;

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
}
